import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Loading from '../../../../common/with-loading-indicator/indicator';

const style = () => ({
	video: {
		width: '100%',
		height: 'calc(100vw * 0.8 * 9 / 16)'
	},
	progress: {
		position: 'absolute',
		top: 'calc(50% - 64px)',
		left: 'calc(50% - 64px)'
	},
	'@media (max-width: 1020px)': {
		video: {
			height: 'calc(100vw * 9 / 16)'
		}
	}
});

const Video = ({
	file, youtube, handleOnLoad, isLoading, classes
}) => (
	<React.Fragment>
		<iframe
			className={classes.video}
			frameBorder="0"
			title={file.name}
			type="text/html"
			src={youtube}
			onLoad={handleOnLoad}
		/>
		{isLoading && <Loading classes={{progress: classes.progress}}/>}
	</React.Fragment>
);

Video.propTypes = {
	classes: PropTypes.object.isRequired,
	file: PropTypes.object.isRequired,
	youtube: PropTypes.string.isRequired,
	handleOnLoad: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired
};

export default withStyles(style)(Video);



// WEBPACK FOOTER //
// ./src/client/components/main/files/video/player/video.jsx